/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BinderClaimPaymentHistoryPaginationResponseDto,
  ClaimPaymentPaginationResponseDto,
  ClaimPaymentResponseDto,
  CreateClaimPaymentPayloadDto,
  ErrorResponse,
  FilterBinderClaimPaymentHistoryQueryDto,
  FilterClaimPaymentsQueryDto,
} from '../models/index';
import {
    BinderClaimPaymentHistoryPaginationResponseDtoFromJSON,
    BinderClaimPaymentHistoryPaginationResponseDtoToJSON,
    ClaimPaymentPaginationResponseDtoFromJSON,
    ClaimPaymentPaginationResponseDtoToJSON,
    ClaimPaymentResponseDtoFromJSON,
    ClaimPaymentResponseDtoToJSON,
    CreateClaimPaymentPayloadDtoFromJSON,
    CreateClaimPaymentPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterBinderClaimPaymentHistoryQueryDtoFromJSON,
    FilterBinderClaimPaymentHistoryQueryDtoToJSON,
    FilterClaimPaymentsQueryDtoFromJSON,
    FilterClaimPaymentsQueryDtoToJSON,
} from '../models/index';

export interface CreateClaimPaymentRequest {
    createClaimPaymentPayloadDto: CreateClaimPaymentPayloadDto;
}

export interface FilterBinderClaimPaymentHistoryRequest {
    claimId: string;
    filterBinderClaimPaymentHistoryQueryDto: FilterBinderClaimPaymentHistoryQueryDto;
    page?: number;
    pageSize?: number;
}

export interface FilterClaimPaymentsRequest {
    filterClaimPaymentsQueryDto: FilterClaimPaymentsQueryDto;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class ClaimPaymentsApi extends runtime.BaseAPI {

    /**
     * Create claim payment
     */
    async createClaimPaymentRaw(requestParameters: CreateClaimPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPaymentResponseDto>> {
        if (requestParameters['createClaimPaymentPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createClaimPaymentPayloadDto',
                'Required parameter "createClaimPaymentPayloadDto" was null or undefined when calling createClaimPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claim-payments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimPaymentPayloadDtoToJSON(requestParameters['createClaimPaymentPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPaymentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create claim payment
     */
    async createClaimPayment(requestParameters: CreateClaimPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPaymentResponseDto> {
        const response = await this.createClaimPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter binder claim payment history
     */
    async filterBinderClaimPaymentHistoryRaw(requestParameters: FilterBinderClaimPaymentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimPaymentHistoryPaginationResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling filterBinderClaimPaymentHistory().'
            );
        }

        if (requestParameters['filterBinderClaimPaymentHistoryQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterBinderClaimPaymentHistoryQueryDto',
                'Required parameter "filterBinderClaimPaymentHistoryQueryDto" was null or undefined when calling filterBinderClaimPaymentHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claim/{claimId}/payments/filter`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterBinderClaimPaymentHistoryQueryDtoToJSON(requestParameters['filterBinderClaimPaymentHistoryQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimPaymentHistoryPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter binder claim payment history
     */
    async filterBinderClaimPaymentHistory(requestParameters: FilterBinderClaimPaymentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimPaymentHistoryPaginationResponseDto> {
        const response = await this.filterBinderClaimPaymentHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter claim payments
     */
    async filterClaimPaymentsRaw(requestParameters: FilterClaimPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPaymentPaginationResponseDto>> {
        if (requestParameters['filterClaimPaymentsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterClaimPaymentsQueryDto',
                'Required parameter "filterClaimPaymentsQueryDto" was null or undefined when calling filterClaimPayments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claim-payments/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterClaimPaymentsQueryDtoToJSON(requestParameters['filterClaimPaymentsQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPaymentPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter claim payments
     */
    async filterClaimPayments(requestParameters: FilterClaimPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPaymentPaginationResponseDto> {
        const response = await this.filterClaimPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get next transaction ID
     */
    async getNextTransactionIdRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claim-payments/next-transaction-id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get next transaction ID
     */
    async getNextTransactionId(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getNextTransactionIdRaw(initOverrides);
        return await response.value();
    }

}
